import React from "react";
import { TableCell } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { TableCellContext, useTableCell } from "./useTableCell";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { toMillimeters } from "../core/pdf/utils";
import { ContentItems } from "./ContentItems";
import { useTable } from "./useTable";

export function TableCellEditor(props: {
	cell: TableCell,
	index: number,
}) {
	const designer = useDesigner();

	const tableState = useTable();
	const table = tableState!.table;

	const parentTableCell = useTableCell();

	const tableCellState = React.useMemo(() => {
		return {
			cell: props.cell, 
			index: props.index,
			col: table.cols[props.index],
		}
	}, [props.cell, props.index]);


	const elementContext = useElementContext(props.cell);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const contentStyle = {} as any;
	if (table.cellPadding) {
		designer.updateStyleMargin(contentStyle, table.cellPadding);
	}

	if (tableCellState.col.widthPercent) {
		contentStyle.width = tableCellState.col.widthPercent + "%";
	}

	if (props.cell.bgColor) {
		contentStyle.backgroundColor = props.cell.bgColor;
	}
	if (props.cell.color) {
		contentStyle.color = props.cell.color;
	}

	return (
		<ElementContext.Provider value={elementContext}>
			<TableCellContext.Provider value={tableCellState}>
				<td
					className={"table-item-editor content-element " + state.classes}
					data-key={props.cell.id}
					id={state.elementID}

					style={contentStyle}
				>
					<ContentItems
						content={props.cell.content}
					/>
				</td>
			</TableCellContext.Provider>
		</ElementContext.Provider>
	)
}